import { TextInput } from "@jugl-web/ui-components";
import { cx, useFormFieldsValidators } from "@jugl-web/utils";
import { CSSProperties, FC, HTMLInputTypeAttribute } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { ChatButton } from "../../../ChatButton";

export interface ChatBotInputsFormProps {
  inputs: {
    name: string;
    type: HTMLInputTypeAttribute;
    isRequired?: boolean;
  }[];
  className?: string;
  style?: CSSProperties;
  onSubmit: (data: { name: string; value: string }[]) => void;
}

interface FormValues {
  fields: { value: string }[];
}

export const ChatBotInputsForm: FC<ChatBotInputsFormProps> = ({
  inputs,
  className,
  style,
  onSubmit,
}) => {
  const { control, formState, register, handleSubmit } = useForm<FormValues>({
    defaultValues: {
      fields: inputs.map(() => ({ value: "" })),
    },
  });

  const { fields } = useFieldArray({ control, name: "fields" });

  const { emailValidator } = useFormFieldsValidators();

  const handleFormSubmit = handleSubmit((data) => {
    onSubmit(
      data.fields.map((field, index) => ({
        name: inputs[index].name,
        value: field.value,
      }))
    );
  });

  return (
    <form
      className={cx("flex w-full flex-col gap-4", className)}
      style={style}
      onSubmit={handleFormSubmit}
      noValidate
    >
      <div className="flex w-full flex-col gap-4">
        {fields.map((field, index) => {
          const inputDef = inputs[index];
          const fieldError = formState.errors.fields?.[index]?.value;

          return (
            <TextInput
              key={field.id}
              type={inputDef.type}
              isRequired={false} // all fields are optional temporarily
              labelPosition="border-overlap"
              size="default"
              placeholder="Enter"
              label={inputDef.name}
              isInvalid={!!fieldError}
              errorMessage={fieldError?.message}
              {...register(`fields.${index}.value`, {
                ...(inputDef.type === "email" && emailValidator()),
              })}
            />
          );
        })}
      </div>
      <ChatButton type="submit" variant="primary" size="md" fullWidth>
        Send
      </ChatButton>
    </form>
  );
};
